import { useSelector } from 'react-redux';
import DesignerPage from './DesignerPage';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useModalAuth from '../../components/auth/AuthModal';
import { useDeviceType } from '../../hooks/useDeviceType';
import PageAlertMobile from '../PageAlertMobile/PageAlertMobile';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const DesignerPageLayout = () => {
  const { user } = useSelector(state => state.auth);
  const [, setOpenModalLogin] = useState(false);
  const navigate = useNavigate();
  const { openLogin } = useModalAuth();
  const device = useDeviceType();
  useDocumentTitle();

  useEffect(() => {
    if (!user) {
      setOpenModalLogin(true);
    }
  }, [user]);

  if (device !== 'desktop') {
    return <PageAlertMobile />;
  }
  if (user) {
    return <DesignerPage />;
  } else {
    return (
      <>
        {(() => {
          openLogin(() => {
            navigate('/');
          });
        })()}
      </>
    );
  }
};

export default DesignerPageLayout;
